export default "__VITE_ASSET__FR0LP4XZ__"